import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  height: 100%;
  padding: 0 20px 20px 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    margin-top: 10px;
  }
`;

export const Header = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: #495057;
  margin: 16px 0 29px 0;
`;
